import { render, staticRenderFns } from "./thread-detail.vue?vue&type=template&id=0973785b&scoped=true&"
import script from "./thread-detail.vue?vue&type=script&lang=js&"
export * from "./thread-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973785b",
  null
  
)

export default component.exports